import { ArrowUpRight, Calendar } from "lucide-react";
import { CALENDLY_URL, FOUNDER_HEADSHOT_URL } from "../constants/site";
import "./BookPill.css";

export const BookPill = ({
    primary = "Book a 20 minute call",
    secondary = "Pick a slot",
    testid = "book-pill",
}) => {
    return (
        <a
            className="book-pill"
            href={CALENDLY_URL}
            target="_blank"
            rel="noopener"
            data-testid={testid}
        >
            {FOUNDER_HEADSHOT_URL ? (
                <img
                    className="book-pill-avatar"
                    src={FOUNDER_HEADSHOT_URL}
                    alt="Founder headshot"
                />
            ) : (
                <span
                    className="book-pill-avatar book-pill-avatar-placeholder"
                    aria-hidden="true"
                    data-testid={`${testid}-avatar-placeholder`}
                >
                    <Calendar size={18} strokeWidth={2} />
                </span>
            )}
            <span className="book-pill-text">
                <span className="book-pill-primary">{primary}</span>
                <span className="book-pill-secondary">
                    <span className="book-pill-dot" aria-hidden="true" />
                    {secondary}
                </span>
            </span>
            <span className="book-pill-arrow" aria-hidden="true">
                <ArrowUpRight size={16} strokeWidth={2.2} />
            </span>
        </a>
    );
};
